export const SET_VENDOR_DRAFT = 'SET_VENDOR_DRAFT';
export const CLEAR_VENDOR_DRAFT = 'CLEAR_VENDOR_DRAFT';


export function setVendorDraft(payload) {
  return {
    type: SET_VENDOR_DRAFT,
    payload,   // payload should be an object: { vendor_name, mobile_no, … }
  };
}

export function clearVendorDraft() {
  return {
    type: CLEAR_VENDOR_DRAFT,
  };
}